var map = {
	"./applelogo.svg": "a954",
	"./arrow.clockwise.svg": "f0cd",
	"./arrow.forward.circle.svg": "5cfe",
	"./arrow.left.svg": "5509",
	"./arrow.right.svg": "cd6e",
	"./arrow.up.backward.and.arrow.down.forward.svg": "cc2a",
	"./chevron.backward.svg": "b64f",
	"./chevron.right.svg": "82e8",
	"./line.diagonal.svg": "bbac",
	"./lock.fill.svg": "64d3",
	"./magnifyingglass.svg": "8dc6",
	"./minus.svg": "1eaf",
	"./plus.svg": "be0a",
	"./restart.circle.svg": "b382",
	"./sidebar.left.svg": "c038",
	"./square.and.arrow.up.svg": "15b3",
	"./switch.svg": "e81d",
	"./xmark.svg": "50b7"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d990";